import { Component, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseService, PartnerDetails } from '@brightside-web/desktop/data-access/shared';
import { ActionCardConfigInterface } from '@brightside/brightside-ui';
import { FindMoneyService } from '../find-money.service';

@Component({
    selector: 'brightside-web-find-money-view',
    templateUrl: './find-money-view.component.html',
    styleUrls: ['./find-money-view.component.scss'],
    standalone: false
})
export class FindMoneyViewComponent implements OnInit {
  partnerCardList$: Observable<ActionCardConfigInterface[] | undefined>;

  constructor(
    private _findMoneyService: FindMoneyService, // ✅ Now using FindMoneyService
    private _analytics: FirebaseService,
    private _router: Router,
    private _route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.partnerCardList$ = this._findMoneyService.findMoneyData$.pipe(
      map((partners: PartnerDetails[] | undefined) => {
        return partners ? partners.map(partner => this._findMoneyService.mapToCardConfig(partner)) : undefined;
      })
    );
  }

  goHome(): void {
    this._router.navigate(['../intro'], { relativeTo: this._route });
  }

  onCtaClicked(partnerCardItem: PartnerDetails): void {
    this._analytics.logEvent('find_money_card', {
      type: partnerCardItem.key,
    });
    this._router.navigate(['../intro', partnerCardItem.key], { relativeTo: this._route });
  }
}
